import { BarsSolid, XmarkSolid } from '@allocab/allocab-icons';
import clsx from 'clsx';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Nav } from './Nav';
import allocabLogo from '../../assets/images/allocab-logo.svg';
import { LocaleSwitch } from '../../components/locale-switch/LocaleSwitch';
import { ReceptionistSelector } from '../../components/ReceptionistSelector';
import { constants } from '../../constants';
import { useFetchAccount } from '../../hooks/useFetchAccount';

export const Header = () => {
  const { data: account } = useFetchAccount();
  const [navOpened, setNavOpened] = useState(false);

  return (
    <>
      <header
        className={clsx(
          'sticky top-0 z-10 peer/header col-span-2 w-full md:w-auto flex items-center bg-background/90 backdrop-blur-lg h-16 justify-between border-b px-2',
          !navOpened && 'nav-closed',
        )}
      >
        <Link to={constants.isHotels ? constants.redirectionHotel : constants.legacyWebappHost}>
          {constants.isHotels ? (
            <p>Allocab Hotels - {account?.name}</p>
          ) : (
            <img src={allocabLogo} alt="Logo Allocab" className="h-6" />
          )}
        </Link>
        <div className="flex items-stretch self-stretch gap-x-2">
          <ReceptionistSelector />
          <LocaleSwitch />
          <button className="md:hidden" onClick={() => setNavOpened(v => !v)}>
            {navOpened ? <XmarkSolid width={16} height={16} /> : <BarsSolid width={16} height={16} />}
          </button>
        </div>
      </header>
      <Nav navOpened={navOpened} closeNav={() => setNavOpened(false)} />
    </>
  );
};
